<template>
  <div :class="['status-message', `status-message--${type}`]">
    <div class="status-message__icon">
      <i :class="iconClass"></i>
    </div>

    <div class="status-message__content">
      <h3 class="status-message__title">{{ title }}</h3>
      <p class="status-message__description">{{ description }}</p>
      <div class="status-message__actions">
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'StatusMessage',
  props: {
    type: {
      type: String,
      default: 'success',
      validator: (value) => ['success', 'warning', 'danger', 'info'].includes(value)
    },
    title: {
      type: String,
      required: true
    },
    description: {
      type: String,
      default: ''
    }
  },
  computed: {
    iconClass() {
      const icons = {
        success: 'fa fa-check-circle',
        warning: 'fa fa-exclamation-triangle',
        danger: 'fa fa-times-circle',
        info: 'fa fa-info-circle'
      };
      return icons[this.type];
    }
  }
}
</script>

<style lang="scss" scoped>
.status-message {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  padding: 48px 24px;
  border-radius: 12px;
  background: #ffffff;
  border: 2px solid;
  max-width: 600px;
  margin: 0 auto;

  &--success {
    border-color: #d4edda;
    background: #f8fdf9;

    .status-message__icon {
      background: #d4edda;
      color: #28a745;
    }
  }

  &--warning {
    border-color: #fff3cd;
    background: #fffef8;

    .status-message__icon {
      background: #fff3cd;
      color: #ffc107;
    }
  }

  &--danger {
    border-color: #f8d7da;
    background: #fef8f8;

    .status-message__icon {
      background: #f8d7da;
      color: #dc3545;
    }
  }

  &--info {
    border-color: #d1ecf1;
    background: #f8fcfd;

    .status-message__icon {
      background: #d1ecf1;
      color: #17a2b8;
    }
  }

  &__icon {
    width: 80px;
    height: 80px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 24px;
    font-size: 36px;
    flex-shrink: 0;
  }

  &__content {
    width: 100%;
  }

  &__title {
    font-size: 24px;
    font-weight: 600;
    margin: 0 0 12px 0;
    color: #212529;
  }

  &__description {
    font-size: 15px;
    color: #6c757d;
    line-height: 1.6;
    margin: 0 0 24px 0;
  }

  &__actions {
    display: flex;
    gap: 12px;
    justify-content: center;
    flex-wrap: wrap;
  }

  @media (max-width: 576px) {
    padding: 32px 20px;

    &__icon {
      width: 64px;
      height: 64px;
      font-size: 28px;
      margin-bottom: 20px;
    }

    &__title {
      font-size: 20px;
    }

    &__description {
      font-size: 14px;
    }
  }
}
</style>
